export default "__VITE_ASSET__C9QB6$T2__"